import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e01cacf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "images" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { clearActiveWidget } from "@/modules/esriMeasure"

// 视图放大

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const reset = () => {
  // 清除测量工具
  clearActiveWidget()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "tool-item",
      onClick: reset
    }, _hoisted_2)
  ]))
}
}

})